export default __webpack_public_path__ + "static/media/ISKO CLASS-6 EXAM PATTERN 2026-27.f8836f2e.pdf";